export default __webpack_public_path__ + "static/media/DP3 1A-1B-1EC.8574c82b.jpg";